import axios from 'axios';

import config from '../../helpers/config';
import withCancellation from '../withCancellation';

const instance = axios.create({
  baseURL: config.thdCartApiUrl,
  withCredentials: true,
  headers: {
    Accept: 'application/json; charset=utf-8',
    'Content-Type': 'application/json',
    'X-Experience-Name': 'custom-measure-and-install',
  },
});

export default withCancellation(instance);
